import AboutUsModule from 'components/about-us/AboutUsModule';
import AboutUsSiteContainer from 'components/about-us/AboutUsSiteContainer';
import ProgressionBar, {
  CurrentUserProgressionBar,
} from 'components/monthly-giveaway/ProgressionBar';
import { DaymadeDesignSystemPreviewComponentInfo } from '.';

const ComponentPreview = () => {
  return (
    <AboutUsModule background="white">
      <AboutUsSiteContainer>
        <h3 className="aboutUsTypographyHeaderLarge">Progression bar</h3>
        <p>
          The progression bar, as used on the Monthly 10k. It is designed to
          fill its container horiziontally. Therefore, its parent container must
          provide any spacing and size the Progression bar appropriately.
          <br />
          <br />
        </p>
        <div style={{ width: '50%' }}>
          <p>This bar uses the currently logged in user's entries</p>
          <CurrentUserProgressionBar />
          <br />
        </div>
        <p>
          The following bars show how the component fills containers of
          different widths
        </p>
        <div style={{ width: '50%' }}>
          <ProgressionBar
            shortMonthName="Sept"
            weekMarkers={[
              { dayNumber: 1, earnings: 5, isMidweek: true },
              { dayNumber: 8, earnings: 5, isMidweek: true },
              { dayNumber: 15, earnings: 5, isMidweek: true },
              { dayNumber: 22, earnings: 5 },
              { dayNumber: 29, earnings: 0 },
            ]}
          />
          <br />
        </div>
        <div style={{ width: '40%' }}>
          <ProgressionBar
            shortMonthName="Mar"
            weekMarkers={[
              { dayNumber: 1, earnings: 5, isMidweek: true },
              { dayNumber: 8, earnings: 5, isMidweek: true },
              { dayNumber: 15, earnings: 5, isMidweek: true },
              { dayNumber: 22, earnings: 5 },
              { dayNumber: 29, earnings: 0 },
            ]}
          />
          <br />
        </div>
        <div style={{ width: '40%' }}>
          <ProgressionBar
            shortMonthName="Jan"
            weekMarkers={[
              { dayNumber: 1, earnings: 0 },
              { dayNumber: 8, earnings: 5, isMidweek: true },
              { dayNumber: 15, earnings: 5, isMidweek: true },
              { dayNumber: 22, earnings: 5, isMidweek: true },
              { dayNumber: 29, earnings: 0 },
            ]}
          />
          <br />
        </div>
        <div style={{ width: '30%' }}>
          <ProgressionBar
            shortMonthName="Dec"
            weekMarkers={[
              { dayNumber: 1, earnings: 5, isMidweek: true },
              { dayNumber: 8, earnings: 5, isMidweek: true },
              { dayNumber: 15, earnings: 5, isMidweek: true },
              { dayNumber: 22, earnings: 0 },
              { dayNumber: 29, earnings: 0 },
            ]}
          />
          <br />
        </div>
      </AboutUsSiteContainer>
    </AboutUsModule>
  );
};

ComponentPreview.daymadeDesignSystemInfo = {
  name: 'Progression Bar',
} as DaymadeDesignSystemPreviewComponentInfo;

export default ComponentPreview;
